import React, {Component} from 'react';
// import styled from "styled-components";
import PropTypes from 'prop-types';

import {MAIN_APP} from '../MidiPlay.jsx';
import UtilDropdown from '../util/UtilDropdown.jsx';

export class MenuSearch extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired
    }

    listen_dropdown(e) {
        MAIN_APP.setState({dropdown: null});
    }

    static options = [
        {label: "General Search", id: 'general-search-menu-item'},
        {type: "separator"},
        {label: "other search options!", id: 'lg-menu-item'}
    ];

    render() {
        return <UtilDropdown
            location={this.props.location}
            items={MenuSearch.options}
            listener={this.listen_dropdown}
        />;
    }
}

export default MenuSearch;